// src/propertyManagement/pages/ApplicantDetailPage.jsx
import React, { useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import {
  Select,
  MenuItem,
  Tabs,
  Tab,
  Divider,
  Checkbox
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import MapIcon from '@mui/icons-material/Map';
import HomeIcon      from '@mui/icons-material/Home';
import PhoneIcon     from '@mui/icons-material/Phone';
import EmailIcon     from '@mui/icons-material/Email';
// reuse your dummyApplicants export
import { dummyApplicants } from './ApplicantsPage';

const tabLabels = [
  'Summary',
  'Financials',
  'Communications',
  'Application',
  'Screening',
  'Rental history verification',
  'Fee',
  'Event history'
];

export default function ApplicantDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const applicant = dummyApplicants.find(a => String(a.id) === id);
  const [status, setStatus]     = useState(applicant?.status || 'Undecided');
  const [tabIndex, setTabIndex] = useState(0);

  // dummy checklist data
  const checklist = [
    {
      title: 'Stage 1: Application',
      items: ['Receive rental application','Review rental application','RTA','TNQ'],
      completed: 4, total: 4,
      logs: [
        { who: 'Jackson Rossi', when: '7/16/2025 2:37 PM' },
        { who: 'Laura Schonbachler', when: '3/21/2025 9:46 AM' },
        { who: 'Anne Villarosa', when: '3/31/2025 4:14 PM' },
        { who: 'Anne Villarosa', when: '3/31/2025 4:14 PM' }
      ]
    },
    {
      title: 'Stage 2: Screening',
      items: ['Receive screening reports','Review screening reports','Review rental history'],
      completed: 3, total: 3,
      logs: [
        { who: 'System', when: '3/21/2025 9:45 AM' },
        { who: 'Laura Schonbachler', when: '3/21/2025 9:46 AM' },
        { who: 'Laura Schonbachler', when: '3/24/2025 8:46 AM' }
      ]
    },
    {
      title: 'Stage 3: Move-in',
      items: ['Collect security deposit','Draft lease','Send lease for signatures','…'],
      completed: 0, total: 5, logs: []
    }
  ];

  if (!applicant) {
    return <div style={styles.container}>Applicant not found</div>;
  }

  return (
    <div style={styles.container}>
      {/* Main Column */}
      <div style={styles.main}>
        {/* Back */}
        <button style={styles.actionBtn} onClick={() => navigate('/pm/applications')}>
          <ArrowBackIcon fontSize="small" /> Back
        </button>

        {/* Header */}
        <h1 style={styles.header}>
          {applicant.firstName} {applicant.lastName} • {applicant.unit}
        </h1>

        {/* Status, Move in, Edit */}
        <div style={styles.buttonGroup}>
          <Select
            value={status}
            onChange={e => setStatus(e.target.value)}
            size="small"
            style={{ width: 140 }}
          >
            {['Undecided','Approved','Denied','Move-in'].map(s => (
              <MenuItem key={s} value={s}>{s}</MenuItem>
            ))}
          </Select>
          <button style={styles.actionBtn}>Move in</button>
          <Link to="#" style={styles.link}>Edit</Link>
        </div>

        {/* Tabs */}
        <nav style={styles.tabs}>
          {tabLabels.map((tab, idx) => (
            <div
              key={tab}
              onClick={() => setTabIndex(idx)}
              style={{
                ...styles.tab,
                ...(tabIndex === idx ? styles.activeTab : {})
              }}
            >
              {tab}
            </div>
          ))}
        </nav>

        {/* Tab Content */}
        <div style={styles.tabContent}>
          {tabIndex === 0 ? (
            <div style={{ display: 'flex', gap: 24 }}>
              {/* Checklist */}
              <div style={{ flex: 2 }}>
                {checklist.map((stage, i) => (
                  <div key={i} style={{ ...styles.card, marginBottom: 16 }}>
                    {/* Title + progress */}
                    <div style={{ ...styles.balanceRow, marginBottom: 8 }}>
                      <span>{stage.title} ({stage.completed}/{stage.total})</span>
                      <div style={{ flex: 1, margin: '0 12px' }}>
                        <div style={{
                          height: 8, background: '#eee', borderRadius: 4, overflow: 'hidden'
                        }}>
                          <div style={{
                            width: `${(stage.completed / stage.total) * 100}%`,
                            height: '100%', background: '#2a9d8f'
                          }} />
                        </div>
                      </div>
                      <span style={{ fontSize: 12 }}>
                        Overall {Math.round(stage.completed/stage.total*100)}% complete
                      </span>
                    </div>
                    <Divider />

                    {/* Items */}
                    {stage.items.map((item, idx) => (
                      <div key={idx} style={{ ...styles.balanceRow, marginTop: 8 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                          <Checkbox
                            checked={idx < stage.completed}
                            icon={<RadioButtonUncheckedIcon fontSize="small" />}
                            checkedIcon={<CheckCircleIcon color="success" fontSize="small" />}
                            size="small"
                            disabled
                          />
                          <span style={{ color: idx < stage.completed ? '#777' : '#000' }}>
                            {item}
                          </span>
                        </div>
                        <span style={{ fontSize: 12, color: '#777' }}>
                          {stage.logs[idx]?.who} {stage.logs[idx]?.when}
                        </span>
                      </div>
                    ))}

                    <div style={{ marginTop: 8 }}>
                      <Link to="#" style={styles.link}>
                        + Add checklist item
                      </Link>
                    </div>
                  </div>
                ))}
              </div>

              {/* Sidebar */}
              <div style={{ ...styles.sidebar, alignItems: 'flex-start' }}>
                {/* Application fee */}
                <div style={styles.card}>
                  <div style={styles.balanceRow}>
                    <span style={styles.balanceLabel}>Application fee</span>
                    <span style={styles.balanceValue}>$0.00</span>
                  </div>
                  <button style={styles.actionBtn}>Receive applicant fee</button>
                </div>

                {/* Applicant info */}
                {/* Applicant info */}
<div style={styles.card}>
  {/* Name & role */}
  <div style={{ marginBottom: 12 }}>
    <strong>
      {applicant.firstName} {applicant.lastName}
    </strong><br/>
    <span style={{ color: '#777' }}>Applicant</span>
  </div>

  {/* Address */}
  <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
    <HomeIcon fontSize="small" color="action" />
    <span>
      161 south olive street, Knoxville, TN 37915
    </span>
  </div>

  {/* Phone */}
  <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
    <PhoneIcon fontSize="small" color="action" />
    <span>
      (865) 355-9352
    </span>
  </div>

  {/* Email */}
  <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 }}>
    <EmailIcon fontSize="small" color="action" />
    <span style={{ textDecoration: 'underline', color: '#06c', cursor: 'pointer' }}>
      nuniesimone@gmail.com
    </span>
  </div>

  {/* Map link, actions */}
  <Link to="#" style={styles.linkSmall}>Map it</Link>
  <Divider style={{ margin: '12px 0' }} />
  <Link to="#" style={styles.linkSmall}>Order Enhanced Tenant Screening</Link><br/>
  <Link to="#" style={styles.linkSmall}>View application</Link>
</div>
              </div>
            </div>
          ) : (
            <p style={styles.emptyText}>
              {tabLabels[tabIndex]} content coming soon…
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

// same styles from PropertyDetail.js
const styles = {
  container:    { display: 'flex', gap: 24, padding: 24 },
  main:         { flex: 3 },
  sidebar:      { flex: 1, display: 'flex', flexDirection: 'column', gap: 16 },
  header:       { margin: 0, fontSize: 24 },
  buttonGroup:  { display: 'flex', alignItems: 'center', gap: 8, margin: '16px 0' },
  actionBtn:    {
    padding: '8px 12px', borderRadius: 4, border: '1px solid #ccc',
    background: '#fff', cursor: 'pointer'
  },
  tabs:         { display: 'flex', borderBottom: '1px solid #ddd' },
  tab:          { padding: '12px 16px', cursor: 'pointer', color: '#555' },
  activeTab:    { borderBottom: '2px solid #000', fontWeight: 'bold', color: '#000' },
  tabContent:   { padding: '16px 0' },
  card:         {
    background: '#f5fcff', border: '1px solid #cce', borderRadius: 8,
    padding: 16, width: '100%'
  },
  balanceRow:   { display: 'flex', justifyContent: 'space-between' },
  balanceLabel: { fontWeight: 'bold' },
  balanceValue: { fontWeight: 'bold' },
  sectionTitle: { marginBottom: 16, fontSize: 20 },
  link:         { color: '#06c', textDecoration: 'none' },
  linkSmall:    { color: '#06c', fontSize: 14, textDecoration: 'none' },
  emptyText:    { color: '#888', fontStyle: 'italic' }
};